import { BASE_CURRENCY, ENDPIONTS, PaginatedResult } from "@api";
import { useFetch } from "@hooks";
import { Branch, DeductionDetail } from "@models";
import { ComplexHeader, Table } from "@shared";
import { useEffect } from "react";

interface Props {
  deductionId: number;
}

const DeductionDetails = ({ deductionId }: Props) => {
  const fetchData = useFetch<PaginatedResult<DeductionDetail>>(
    { endPoint: ENDPIONTS.deductionDetails, id: deductionId },
    new PaginatedResult<DeductionDetail>()
  );

  useEffect(() => {}, [fetchData?.isFetching, deductionId]);

  const headers: ComplexHeader[] = [
    {
      key: "deductedAmount",
      title: "deducted Amount",
      format: "currency",
      currency: () => BASE_CURRENCY,
    },
    { key: "forMonth", title: "for Month" },
    { key: "status", title: "status" },
    { key: "ref", title: "ref" },
    { key: "createdAt", title: "@", format: "date" },
  ];

  return (
    <>
      <h3>Loan Details</h3>
      <hr />
      <Table
        class="table table-striped table-hover mb-0"
        data={fetchData?.data ?? []}
        headers={headers}
        isFetchingPage={fetchData.isFetching}
        showCounter
        paginationClass="row mt-3"
      />
    </>
  );
};

export default DeductionDetails;
